import { useUserCountry } from '@/components/modal/sign-in-modal/compliant-logos/hooks/useUserCountry';
import { useIsProjectsEnabled } from '@/features/flags';
import { useAuthToken } from '@/hooks/useAuthToken';
import { useEvidenceAccess } from '@/hooks/useEvidenceAccess';

/**
 * Whether the CPD surfaces should read "CME". The country inference is app
 * session state, so the package's term hooks take the resolved boolean.
 */
export const useIsCpdUsUser = (): boolean => useUserCountry() === 'US';

/** Whether CPD API queries may run — matches CPD page entitlement. */
export function useIsCpdQueryEnabled(): boolean {
  const token = useAuthToken();
  const { isSessionlessEvidenceShown, isPending } = useEvidenceAccess();
  return Boolean(token && isSessionlessEvidenceShown && !isPending);
}

/** CPD entry in the Work account menu (Work ON). */
export function useIsCpdAccountMenuShown(): boolean {
  const isWorkEnabled = useIsProjectsEnabled();
  const { isSessionlessEvidenceShown, isPending } = useEvidenceAccess();
  return isWorkEnabled && isSessionlessEvidenceShown && !isPending;
}

/** CPD entry in the Evidence sidebar (Work OFF). */
export function useIsCpdSidebarShown(isAuthenticated: boolean): boolean {
  const isWorkEnabled = useIsProjectsEnabled();
  const { isSessionlessEvidenceShown, isPending } = useEvidenceAccess();
  return isAuthenticated && !isWorkEnabled && isSessionlessEvidenceShown && !isPending;
}

/** CPD skeleton placeholders while the Evidence sidebar loads. */
export function useIsCpdSidebarSkeletonShown(): boolean {
  return useIsCpdSidebarShown(true);
}
